import React, { useState } from 'react';

// The dashed "add a number" tile at the end of the goal grid. Tap it and the
// numbers you could add appear as pills right there.

const AddNumber = ({ available, onAdd, busy }) => {
  const [open, setOpen] = useState(false);
  if (!available.length) return null;
  const teaser = available.slice(0, 3).map((t) => t.label.replace(/\s*\(.*\)$/, '').toLowerCase());

  return (
    <div className="mt-3.5">
      {open ? (
        <div className="rounded-xl border border-line px-5 py-4">
          <div className="flex items-baseline justify-between gap-3">
            <p className="text-base font-medium">Which number?</p>
            <button type="button" onClick={() => setOpen(false)} className="bg-transparent p-0 text-sm font-medium text-fg-3 hover:text-fg">Close</button>
          </div>
          <div className="mt-3 flex flex-wrap gap-2">
            {available.map((t) => (
              <button key={t.metric_key} type="button" disabled={busy}
                onClick={() => { onAdd(t.metric_key); setOpen(false); }}
                className="rounded-full border border-line-strong px-4 py-2 text-base font-medium text-fg-2 transition-colors hover:border-fg-3 hover:text-fg disabled:opacity-50">
                {t.label}
              </button>
            ))}
          </div>
        </div>
      ) : (
        <button type="button" onClick={() => setOpen(true)}
          className="grid min-h-[160px] w-full place-items-center rounded-xl border border-dashed border-line-strong bg-transparent px-5 py-5 text-center text-[1.05rem] font-medium text-fg-2 transition-colors hover:bg-raised hover:text-fg">
          <span>
            + Add a number to steer
            <small className="mt-1.5 block text-sm font-normal text-fg-3">
              {teaser.length ? `${teaser.join(', ')}${available.length > 3 ? ', and more' : ''}` : ''}
            </small>
          </span>
        </button>
      )}
    </div>
  );
};

export default AddNumber;
